<div class="main-wrapper">
  <div class="row justify-content-center mb-4">
    <div class="col-12">
      <!-- <div class="d-flex align-items-center justify-content-between">
      <div class="fs-20 font-weight-700">{{ 'MAIN.LOBBY.LOBBY_SHARED.UPCOMING_MEETINGS_TITLE' | translate }}</div>
      <div>
        <a class="change-layout-link fs-14 font-weight-600 cursor-pointer hover-underline">View all Meetings</a>
        <button *ngIf="scheduleMeetingAvailable && isUserExpert" class="btn btn-primary fs-15 font-weight-600 schedule-button ms-3" (click)="scheduleMeeting()">{{ 'MAIN.LOBBY.LOBBY_SHARED.SCHEDULE_MEETING' | translate }}</button>
      </div>
    </div> -->
    @if (roomsLoading) {
      <div class="d-flex justify-content-center">
        <div class="loader loader-sm la-dark"><div></div><div></div><div></div><div></div><div></div></div>
      </div>
    }
    @if (!roomsLoading && upcomingMeetings.length === 0 && previousMeetings.length === 0) {
      <div class="fs-14 text-dark-grey mt-4">{{ 'MAIN.LOBBY.LOBBY_SHARED.NO_MEETING' | translate }}</div>
    }
    @if (!roomsLoading && upcomingMeetings.length === 0 && isOverview) {
      <button class="v-btn btn btn-primary vsight-button vsight-secondary-btn mt-4" (click)="createMeetingClicked()">{{ 'MAIN.LOBBY.LOBBY_SHARED.SCHEDULE_MEETING' | translate }}</button>
    }

    @for (room of upcomingMeetings; track room; let i = $index) {
      <div class="room">
        <div class="row">
          <div class="col-7">
            <div class="d-flex flex-column h-100 justify-content-center ">
              <div class="room-header d-flex align-items-center flex-row">
                <div class="fs-18 font-weight-600 ml-2">{{ room.room_data.name }}</div>
              </div>
              @if (room.room_data.meeting_room) {
                <div class="room-description mt-3">
                  @if (room.room_data.meeting_type !== 'outlook') {
                    <div class="d-flex flex-row align-items-center mb-2">
                      <!-- <i class="mi mi-schedule mr-2"></i> -->
                      <div>
                        <div class="mb-1 fs-14 d-flex align-items-center">
                          <img src="assets/img/date-picker-blue.svg" alt="" class="me-2">
                        {{ room.room_data.start | date:'dd.MM.yyyy HH:mm O' | convertUtc }}</div>
                        <!-- <div>{{ room.room_data.end | date:'dd.MM.yyyy HH:mm O' | convertUtc }}</div> -->
                      </div>
                    </div>
                  }
                  <div class="own-room-link mb-2 d-flex">
                    <img src="assets/img/link.svg" alt="" class="me-2">
                    @if (room.room_data.invalidate_link) {
                      <div class="w-100 d-flex align-items-center justify-content-between" style="overflow-x: hidden;">
                        <span class="text-muted">{{ 'MAIN.LOBBY.LOBBY_SHARED.LINK_UNAVAILABLE' | translate }}</span>
                      </div>
                    }
                    @if (!room.room_data.invalidate_link) {
                      <div class="d-flex align-items-center justify-content-between" style="overflow: hidden;">
                                            <a #link class="join-link fs-14 short-link cursor-pointer" [copy-clipboard]="websiteOrigin+'/joinroom?id='+room.room_data.link_id" [select-text]="link" (copied)="joinLinkCopied($event)">{{ websiteOrigin+'/joinroom?id='+room.room_data.link_id }}</a>
                                            <a class="copy-button icon-button ms-2 cursor-pointer" [copy-clipboard]="websiteOrigin+'/joinroom?id='+room.room_data.link_id" [select-text]="link" (copied)="joinLinkCopied($event)">
                                                <img src="assets/img/copy-content.svg" alt="">
                                            </a>
                                        </div>
                                        <div class="btn-group text-center d-flex align-items-center justify-content-between" dropdown>
                                            <button id="button-1" dropdownToggle type="button" class="btn btn-sm py-0 text-center d-flex align-items-center justify-content-center" aria-controls="dropdown-1">
                                                <a class="share-button icon-button">
                                                    <img src="assets/img/connection-icon.svg" alt="">
                                                </a>
                                            </button>
                                            <ul id="dropdown-1" *dropdownMenu class="join-dropdown-menu dropdown-menu dropdown-menu-right py-1" role="menu" aria-labelledby="button-1" style="width: 100%;">
                                                <li role="menuitem" style="cursor: pointer;">
                                                    <a (click)="onMailGenerating(websiteOrigin+'/joinroom?id='+room.room_data.link_id)" class="dropdown-item d-flex justify-content-start" style="font-size: 15px;" [href]="mailToUrl"  target="_blank">         <i class="mi mi-mail mr-3 d-flex justify-content-start" style="font-size: 15px;">                 </i>E-mail</a>
                                                </li>
                                                <li role="menuitem" style="cursor: pointer">
                                                    <a (click)="onWhatsappGenerating(websiteOrigin+'/joinroom?id='+room.room_data.link_id)" class="dropdown-item d-flex justify-content-start" style="font-size: 15px;" [href]="whatsappToUrl" target="_blank"> <i class="mi mi-sms mr-3 d-flex justify-content-start" style="font-size: 15px;">                  </i>Whatsapp</a>
                                                </li>
                                                <li role="menuitem" style="cursor: pointer">
                                                    <a [ngClass]="{'disabled': !smsAccountEnabled}" (click)="onSMSGenerating(websiteOrigin+'/joinroom?id='+room.room_data.link_id, room.room_data.link_id)" class="dropdown-item d-flex justify-content-start" style="font-size: 15px;"><i class="mi mi-stay-current-portrait mr-3 d-flex justify-content-start" style="font-size: 15px;"></i>SMS</a>
                                                </li>
                                            </ul>
                                        </div>
                                    
}
                                </div>
                            </div>
}
                        </div>
                    </div>
                    <div class="col-3 divided">
                        <div class="vertical-divider"></div>
                        <div class="d-flex flex-column h-100 justify-content-center ">
                            @if (room.room_data.users.length === 0) {
<div class="fs-14 text-dark-grey">{{ 'MAIN.LOBBY.LOBBY_SHARED.NO_OTHER_USERS' | translate }}</div>
}
                            @for (user of room.room_data.users; track user; let ui = $index) {

                                @if (showRoomUsers[room.id] || ui < 3) {
<div class="room-user pt-1 fs-14" [ngClass]="{'in-room-user': user.in_room, 'not-in-room-user': !user.in_room}">{{ user.name }}</div>
}
                            
}
                            @if (room.room_data.users.length > 3) {

                                @if (!showRoomUsers[room.id]) {
<a (click)="showRoomUsers[room.id] = true" class="text-muted pt-1" style="font-size: 12px; font-weight: 600; cursor: pointer;">{{ 'MAIN.LOBBY.LOBBY_SHARED.SHOW_MORE' | translate:{count:room.room_data.users.length-3} }}</a>
}
                                @if (showRoomUsers[room.id]) {
<a (click)="showRoomUsers[room.id] = false" class="text-muted pt-1" style="font-size: 12px; font-weight: 600; cursor: pointer;">{{ 'MAIN.LOBBY.LOBBY_SHARED.SHOW_LESS' | translate }}</a>
}
                            
}
                        </div>
                    </div>
                    <div class="col-2 divided">
                        <div class="vertical-divider d-md-block d-none"></div>
                        <div class="horizontal-divider d-md-none d-block"></div>
                        <div class="d-flex h-100 flex-column justify-content-center align-items-center ">
                            <div class="d-flex flex-column">
                                <button (click)="onJoin(room)" class="v-btn btn btn-primary vsight-button">{{ 'MAIN.LOBBY.LOBBY_SHARED.JOIN' | translate }}</button>
                                @if (room.room_data.meeting_room === currentUser.id) {
<button (click)="cancelMeeting(room, false)" class="btn btn-primary cancel-button mt-2">{{ 'MAIN.LOBBY.LOBBY_SHARED.CANCEL' | translate }}</button>
}    
                            </div>
                        </div>
                    </div>
                </div>
            </div>
}
            <!-- end of upcoming meetings -->

            <!-- <div class="d-flex justify-content-between mt-4">
                <div class="fs-20 font-weight-700">{{ 'MAIN.LOBBY.LOBBY_SHARED.PREVIOUS_MEETINGS_TITLE' | translate }}</div>
            </div> -->
            @if (roomsLoading) {
<div class="d-flex justify-content-center">
                <div class="loader loader-sm la-dark"><div></div><div></div><div></div><div></div><div></div></div>
            </div>
}
            @if (!isOverview) {

            
                @for (room of previousMeetings; track room; let i = $index) {
<div class="room">
                
                    <div class="row">
                        <div [ngClass]="{'col-10': room.room_data.archive, 'col-7': !room.room_data.archive}">
                            <div class="d-flex flex-column h-100 justify-content-center ">
                                <div class="room-header d-flex align-items-center flex-row">
                                    <div class="fs-18 font-weight-600 ml-2">{{ room.room_data.name }}</div>
                                </div>
                                @if (room.room_data.meeting_room) {
<div class="room-description mt-3">
                                    <div class="d-flex flex-row align-items-center mb-2">
                                        <!-- <i class="mi mi-schedule mr-2"></i> -->
                                        <div>
                                            <div class="mb-1 fs-14 d-flex align-items-center">
                                                <img src="assets/img/date-picker-blue.svg" alt="" class="me-2">
                                                {{ room.room_data.start | date:'dd.MM.yyyy HH:mm O' | convertUtc }}</div>
                      <!-- <div>{{ room.room_data.end | date:'dd.MM.yyyy HH:mm O' | convertUtc }}</div> -->
                    </div>
                  </div>
                  <div class="own-room-link mb-2 d-flex">
                    <img src="assets/img/link.svg" alt="" class="me-2">
                    @if (room.room_data.invalidate_link) {
                      <div class="w-100 d-flex align-items-center justify-content-between" style="overflow-x: hidden;">
                        <span class="text-muted">{{ 'MAIN.LOBBY.LOBBY_SHARED.LINK_UNAVAILABLE' | translate }}</span>
                      </div>
                    }
                    @if (!room.room_data.invalidate_link) {
                      <div class="d-flex align-items-center justify-content-between" style="overflow: hidden;">
                                                <a #link class="join-link fs-14 short-link cursor-pointer" [copy-clipboard]="websiteOrigin+'/joinroom?id='+room.room_data.link_id" [select-text]="link" (copied)="joinLinkCopied($event)">{{ websiteOrigin+'/joinroom?id='+room.room_data.link_id }}</a>
                                                <a class="copy-button icon-button ms-2 cursor-pointer" [copy-clipboard]="websiteOrigin+'/joinroom?id='+room.room_data.link_id" [select-text]="link" (copied)="joinLinkCopied($event)">
                                                    <img src="assets/img/copy-content.svg" alt="">
                                                </a>
                                            </div>
                                            <div class="btn-group text-center d-flex align-items-center justify-content-between" dropdown>
                                                <button id="button-1" dropdownToggle type="button" class="btn btn-sm py-0 text-center d-flex align-items-center justify-content-center" aria-controls="dropdown-1">
                                                    <a class="share-button icon-button">
                                                        <img src="assets/img/connection-icon.svg" alt="">
                                                    </a>
                                                </button>
                                                <ul id="dropdown-1" *dropdownMenu class="join-dropdown-menu dropdown-menu dropdown-menu-right py-1" role="menu" aria-labelledby="button-1" style="width: 100%;">
                                                    <li role="menuitem" style="cursor: pointer;">
                                                        <a (click)="onMailGenerating(websiteOrigin+'/joinroom?id='+room.room_data.link_id)" class="dropdown-item d-flex justify-content-start" style="font-size: 15px;" [href]="mailToUrl"  target="_blank">         <i class="mi mi-mail mr-3 d-flex justify-content-start" style="font-size: 15px;">                 </i>E-mail</a>
                                                    </li>
                                                    <li role="menuitem" style="cursor: pointer">
                                                        <a (click)="onWhatsappGenerating(websiteOrigin+'/joinroom?id='+room.room_data.link_id)" class="dropdown-item d-flex justify-content-start" style="font-size: 15px;" [href]="whatsappToUrl" target="_blank"> <i class="mi mi-sms mr-3 d-flex justify-content-start" style="font-size: 15px;">                  </i>Whatsapp</a>
                                                    </li>
                                                    <li role="menuitem" style="cursor: pointer">
                                                        <a [ngClass]="{'disabled': !smsAccountEnabled}" (click)="onSMSGenerating(websiteOrigin+'/joinroom?id='+room.room_data.link_id, room.room_data.link_id)" class="dropdown-item d-flex justify-content-start" style="font-size: 15px;"><i class="mi mi-stay-current-portrait mr-3 d-flex justify-content-start" style="font-size: 15px;"></i>SMS</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        
}
                                    </div>
                                </div>
}
                            </div>
                        </div>
                        @if (!room.room_data.archive) {
<div class="col-3 divided">
                            <div class="vertical-divider"></div>
                            <div class="d-flex flex-column h-100 justify-content-center ">
                                @if (room.room_data.users.length === 0) {
<div class="fs-14 text-dark-grey">{{ 'MAIN.LOBBY.LOBBY_SHARED.NO_OTHER_USERS' | translate }}</div>
}
                                @for (user of room.room_data.users; track user; let ui = $index) {

                                    @if (showRoomUsers[room.id] || ui < 3) {
<div class="room-user pt-1 fs-14" [ngClass]="{'in-room-user': user.in_room, 'not-in-room-user': !user.in_room}">{{ user.name }}</div>
}
                                
}
                                @if (room.room_data.users.length > 3) {

                                    @if (!showRoomUsers[room.id]) {
<a (click)="showRoomUsers[room.id] = true" class="text-muted pt-1" style="font-size: 12px; font-weight: 600; cursor: pointer;">{{ 'MAIN.LOBBY.LOBBY_SHARED.SHOW_MORE' | translate:{count:room.room_data.users.length-3} }}</a>
}
                                    @if (showRoomUsers[room.id]) {
<a (click)="showRoomUsers[room.id] = false" class="text-muted pt-1" style="font-size: 12px; font-weight: 600; cursor: pointer;">{{ 'MAIN.LOBBY.LOBBY_SHARED.SHOW_LESS' | translate }}</a>
}
                                
}
                            </div>
                        </div>
}
                        <div class="col-2 divided">
                            <div class="vertical-divider d-md-block d-none"></div>
                            <div class="horizontal-divider d-md-none d-block"></div>
                            <div class="d-flex h-100 flex-column justify-content-center align-items-center ">
                                <div class="d-flex flex-column">
                                    <button (click)="onJoin(room)" class="v-btn btn btn-primary vsight-button">{{ 'MAIN.LOBBY.LOBBY_SHARED.JOIN' | translate }}</button>
                                    @if (room.room_data.meeting_room === currentUser.id) {
<button (click)="cancelMeeting(room, true)" class="btn btn-primary cancel-button mt-2">{{ 'MAIN.LOBBY.LOBBY_SHARED.REMOVE' | translate }}</button>
}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
}
            
}
            

            <!-- show more eklenmek istenirse -->

            <!-- <button class="btn btn-outline-dark btn-sm btn-block rounded-0 mt-2" *ngIf="previousMeetings.length > previousDefaultVisible" (click)="showMorePrevious = !showMorePrevious; checkShowMorePrevious()">
                {{ (showMorePrevious ? 'MAIN.LOBBY.LOBBY_SHARED.SHOW_LESS' : 'MAIN.LOBBY.LOBBY_SHARED.SHOW_MORE') | translate:{count:previousMeetings.length - previousDefaultVisible} }}
</button> -->


<!-- end of previous meetings -->

<!--<button class="btn btn-outline-dark btn-sm btn-block rounded-0 mt-5" (click)="showArchivedMeetings()">Show Archived Meetings</button>

<div *ngFor="let room of archivedMeetings; let i = index" class="room rounded-0 card-1 mt-2 py-0 px-2">

  <div class="row px-2">
    <div class="col-12">
      <div class="d-flex flex-column h-100 justify-content-center ">
        <div class="room-header d-flex align-items-center flex-row">
          <div class="room-icon border border-light">
            <img src="{{ room.room_data.icon }}" alt="Room Icon">
          </div>
          <div class="room-name ml-2">{{ room.room_data.name }} {{ room.room_data.link_id }}</div>
        </div>
        <div *ngIf="room.room_data.meeting_room" class="room-description mt-3">
          <div class="d-flex flex-row align-items-center mb-2">
            <i class="mi mi-schedule mr-2"></i>
            <div>
              <div class="mb-1">{{ room.room_data.start | date:'dd.MM.yyyy HH:mm O' | convertUtc }}</div>
              <div>{{ room.room_data.end | date:'dd.MM.yyyy HH:mm O' | convertUtc }}</div>
            </div>
          </div>
          <div class="d-flex flex-row align-items-center mb-2">
            <i class="mi mi-timer mr-2"></i>
            <div>{{ getMeetingDuration(room.room_data.start, room.room_data.end) }}</div>
          </div>
          <div class="own-room-link mb-2" *ngIf="!room.room_data.invalidate_link">
            <i class="mi mi-link mr-2"></i>
            <div class="w-100 d-flex align-items-center justify-content-between" style="overflow: hidden;">
                                        <a #link class="join-link text-muted" [copy-clipboard]="websiteOrigin+'/joinroom?id='+room.room_data.link_id" [select-text]="link" (copied)="joinLinkCopied($event)">{{ websiteOrigin+'/joinroom?id='+room.room_data.link_id }}</a>
                                        <a class="copy-button rounded-circle ml-2" [copy-clipboard]="websiteOrigin+'/joinroom?id='+room.room_data.link_id" [select-text]="link" (copied)="joinLinkCopied($event)">
                                            <i class="mi mi-content-copy copy-icon"></i>
                                        </a>
                                    </div>
                                    <div class="btn-group text-center d-flex align-items-center justify-content-between" dropdown>
                                        <button id="button-1" dropdownToggle type="button" class="btn btn-sm text-center d-flex align-items-center justify-content-center" aria-controls="dropdown-1">
                                            <a class="share-button rounded-circle">
                                                <i class="mi mi-share share-icon" style="margin-top: 4px; font-size: 19px;"></i>
                                            </a>
                                        </button>
                                        <ul id="dropdown-1" *dropdownMenu class="join-dropdown-menu dropdown-menu dropdown-menu-right py-1" role="menu" aria-labelledby="button-1" style="width: 100%;">
                                            <li role="menuitem" style="cursor: pointer;">
                                                <a (click)="onMailGenerating(websiteOrigin+'/joinroom?id='+room.room_data.link_id)" class="dropdown-item d-flex justify-content-start" style="font-size: 15px;" [href]="mailToUrl"  target="_blank">         <i class="mi mi-mail mr-3 d-flex justify-content-start" style="font-size: 15px;">                 </i>E-mail</a>
                                            </li>
                                            <li role="menuitem" style="cursor: pointer">
                                                <a (click)="onWhatsappGenerating(websiteOrigin+'/joinroom?id='+room.room_data.link_id)" class="dropdown-item d-flex justify-content-start" style="font-size: 15px;" [href]="whatsappToUrl" target="_blank"> <i class="mi mi-sms mr-3 d-flex justify-content-start" style="font-size: 15px;">                  </i>Whatsapp</a>
                                            </li>
                                            <li role="menuitem" style="cursor: pointer">
                                                <a [ngClass]="{'disabled': !smsAccountEnabled}" (click)="onSMSGenerating(websiteOrigin+'/joinroom?id='+room.room_data.link_id, room.room_data.link_id)" class="dropdown-item d-flex justify-content-start" style="font-size: 15px;"><i class="mi mi-stay-current-portrait mr-3 d-flex justify-content-start" style="font-size: 15px;"></i>SMS</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-5 divided">
                        <div class="vertical-divider"></div>
                        <div class="d-flex flex-column h-100 justify-content-center ">
                        </div>
                    </div>
                    <div class="col-md-2 col-12 divided">
                        <div class="vertical-divider d-md-block d-none"></div>
                        <div class="horizontal-divider d-md-none d-block"></div>
                        <div class="d-flex h-100 flex-column justify-content-center align-items-center ">
                            <div class="d-flex flex-column">
                                <button (click)="onJoin(room)" class="btn rounded-0 btn-outline-dark btn-sm btn-block px-2">{{ 'MAIN.LOBBY.LOBBY_SHARED.JOIN' | translate }}</button>
                                <button *ngIf="room.room_data.meeting_room === currentUser.id" (click)="cancelMeeting(room, true)" class="btn rounded-0 btn-outline-info btn-sm btn-block px-2 mt-1">{{ 'MAIN.LOBBY.LOBBY_SHARED.REMOVE' | translate }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>-->
        </div>
    </div>
</div>

<ng-template #notSupportedTemplate let-dataModel="dataModel" let-callbacks="callbacks">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{ 'MAIN.LOBBY.NOT_SUPPORTED_TITLE' | translate }}</h5>
            </div>
            <div class="modal-body px-0 py-4">
                @if (!dataModel.ios) {
<p class="mx-3">{{ 'MAIN.LOBBY.NOT_SUPPORTED_MESSAGE' | translate }}</p>
}
                @if (dataModel.ios) {

                    @if (!dataModel.ios_version_low) {
<p class="mx-3 mb-3">{{ 'MAIN.LOBBY.NO_IOS_MESSAGE' | translate:('design' | env) }}</p>
}
                    @if (dataModel.ios_version_low) {
<p class="mx-3 mb-3">{{ 'MAIN.LOBBY.IOS_VERSION_MESSAGE' | translate:('design' | env) }}</p>
}
                    <div class="d-flex justify-content-center">
                        <a [href]="('design' | env).appStoreLink" target="_blank" rel="noopener">
                            <img class="d-block mx-auto" style="width: 80%; max-width: 200px; object-fit: contain;" src="assets/badges/applestore.png">
                        </a>
                    </div>
                
}
            </div>

            <div class="modal-footer d-block text-right py-2 px-3">
                <button class="btn btn-sm btn-dark px-4" (click)="callbacks.close()">{{ 'MAIN.LOBBY.NOT_SUPPORTED_CLOSE' | translate }}</button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #joinTemplate let-dataModel="dataModel" let-callbacks="callbacks">
    <div class="modal-dialog join-room-dialog" role="document">
        <div class="modal-content">
            <div class="modal-body p-0">
                <div class="video-container">

                    @if (dataModel.status === 'permission-denied') {
            <div>
              <div class="redbox d-flex justify-content-center">
                <i class="mi mi-videocam-off" style="color: white; font-size: 50px; opacity: 0.9;"></i>
              </div>
            </div>
          }
          <video [ngStyle]="{'transform': cameraMirror ? 'scaleX(-1)' : 'scaleX(1)'}" #videoElement autoplay="true" playsinline="true" muted></video>

          @if (dataModel.status === 'running' && !dataModel.videoEnabled) {
            <div>
              <div class="blackbox d-flex justify-content-center">
                <i class="mi mi-videocam-off" style="color: white; font-size: 50px; opacity: 0.9;"></i>
              </div>
            </div>
          }
          <video [ngStyle]="{'transform': cameraMirror ? 'scaleX(-1)' : 'scaleX(1)'}" #videoElement autoplay="true" playsinline="true" muted></video>

          <div class="video-controls">
            <a class="control" (enabledClick)="callbacks.toggleVideo();" [fakeDisabled]="dataModel.status !== 'running' || dataModel.videos.length === 0" [ngClass]="{'video-disabled': !dataModel.videoEnabled}">
              <i class="mi" [ngClass]="{'mi-videocam': dataModel.videoEnabled, 'mi-videocam-off': !dataModel.videoEnabled}"></i>
            </a>
            <a class="control ml-2" (enabledClick)="callbacks.toggleAudio();" [fakeDisabled]="dataModel.status !== 'running' || dataModel.audios.length === 0" [ngClass]="{'audio-disabled': !dataModel.audioEnabled}">
              <div class="audio-level" [style.height.%]="dataModel.audioEnabled ? dataModel.audioLevel : 0"></div>
              <i class="mi" [ngClass]="{'mi-mic': dataModel.audioEnabled, 'mi-mic-off': !dataModel.audioEnabled}"></i>
            </a>
          </div>

          <div class="video-settings">
            <a class="control" (enabledClick)="dataModel.settingsOn = !dataModel.settingsOn" [fakeDisabled]="dataModel.status !== 'running'">
              <i class="mi mi-settings"></i>
            </a>
          </div>
        </div>
        <div class="settings-container py-3" [ngClass]="{'show': dataModel.settingsOn}">
          <form #settingsForm="ngForm">
            @if (('design' | env).showPreferredResolution) {
              <div class="form-row justify-content-center">
                <div class="form-group col-11 col-sm-10 mb-1">
                  <label class="mb-1" for="publishResolution">{{ 'MAIN.LOBBY.JOIN_MODAL.PREFERRED_RESOLUTION' | translate }}</label>
                  <!-- <ng-select name="publishResolution" [items]="dataModel.publishResolutions" [clearable]="false" [searchable]="false" [dropdownPosition]="'top'"
                [(ngModel)]="opentokService.selectedPublishResolution"></ng-select> -->
              </div>
              <div class="text-info col-11 col-sm-10 mb-3">{{ 'MAIN.LOBBY.JOIN_MODAL.RESOLUTION_NOTE' | translate }}</div>
            </div>
          }
          <div class="form-row justify-content-center">
            <div class="form-group col-11 col-sm-5 mb-2 mb-sm-0">
              <ng-select [items]="dataModel.videos" [clearable]="false" name="videoSetting" bindLabel="label" bindValue="deviceId" [searchable]="false" [disabled]="!dataModel.videoEnabled"
              placeholder="Video Device" [(ngModel)]="dataModel.selectedVideo" (change)="callbacks.changeVideoSource($event)" [dropdownPosition]="'top'"></ng-select>
            </div>
            <div class="form-group col-11 col-sm-5 mb-0">
              <ng-select [items]="dataModel.audios" [clearable]="false" name="audioSetting" bindLabel="label" bindValue="deviceId" [searchable]="false" [disabled]="!dataModel.audioEnabled"
              placeholder="Audio Device" [(ngModel)]="dataModel.selectedAudio" (change)="callbacks.changeAudioSource($event)" [dropdownPosition]="'top'"></ng-select>
            </div>
          </div>
          <div class="form-row justify-content-center">
            <div class="form-group col-11 col-sm-10 mb-0">
              <div class="custom-control custom-checkbox d-flex align-items-center">
                <input type="checkbox" class="custom-control-input" id="mirror" name="mirror" [(ngModel)]="cameraMirror" (ngModelChange)="cameraMirrorChanged($event)">
                <label class="custom-control-label" for="mirror">{{ 'MAIN.LOBBY.JOIN_MODAL.MIRROR_VIDEO' | translate }}</label>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="message-container">
        @switch (dataModel.status) {
          @case ('permission-required') {
            <span class="mt-2 p-2">{{ 'MAIN.LOBBY.JOIN_MODAL.CAM_MIC_PERM_REQUIRED' | translate }}</span>
          }
          @case ('permission-denied') {
            <span class="mt-2 p-2">{{ 'MAIN.LOBBY.JOIN_MODAL.CAM_MIC_PERM_DENIED' | translate }}</span>
          }
          @case ('cant-access-devices') {
            <span class="mt-2 p-2">{{ 'MAIN.LOBBY.JOIN_MODAL.CAM_MIC_CANT_ACCESS' | translate }}</span>
          }
          @case ('no-devices-found') {
            <span class="mt-2 p-2">{{ 'MAIN.LOBBY.JOIN_MODAL.JOIN_NO_DEVICE' | translate }}</span>
          }
          @case ('running') {
            @if (!dataModel.audioEnabled && dataModel.videoEnabled) {
              <span class="mt-2 p-2">{{ 'MAIN.LOBBY.JOIN_MODAL.JOIN_MIC_OFF' | translate }}</span>
            }
            @if (!dataModel.videoEnabled && dataModel.audioEnabled) {
              <span class="mt-2 p-2">{{ 'MAIN.LOBBY.JOIN_MODAL.JOIN_CAM_OFF' | translate }}</span>
            }
            @if (!dataModel.audioEnabled && !dataModel.videoEnabled) {
              <span class="mt-2 p-2">{{ 'MAIN.LOBBY.JOIN_MODAL.JOIN_CAM_MIC_OFF' | translate }}</span>
            }
          }
        }
      </div>
    </div>
    @if (dataModel.status === 'permission-denied') {
      <div class="prompt-text px-3 py-4">
        <p class="px-1 py-2 mt-2">{{ 'MAIN.LOBBY.JOIN_MODAL.ALLOW_ACCESS' | translate }}</p>
        <p class="font-weight-bold px-3 py-2 mb-1">{{ 'MAIN.LOBBY.JOIN_MODAL.TRY_AGAIN' | translate }}</p>
      </div>
    }
    <div class="modal-footer d-block text-right py-2 px-3">
      <button class="btn btn-responsive btn-sm btn-outline-dark px-3" (click)="callbacks.close()" [disabled]="!dataModel.enableCancel">{{ 'MAIN.LOBBY.JOIN_MODAL.CANCEL' | translate }}</button>
      <button class="btn btn-responsive btn-sm btn-dark px-4" (click)="callbacks.join()" [disabled]="!dataModel.enableJoin">{{ 'MAIN.LOBBY.JOIN_MODAL.JOIN' | translate }}</button>
    </div>
  </div>
</div>
</ng-template>

<ng-template #noDeviceTemplate let-callbacks="callbacks">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ 'MAIN.LOBBY.NO_DEVICE_MODAL.TITLE' | translate }}</h5>
      </div>
      <div class="modal-body px-0 py-4">
        <p class="mx-3">{{ 'MAIN.LOBBY.NO_DEVICE_MODAL.JOIN_BODY' | translate }}</p>
      </div>
      <div class="modal-footer d-block text-right py-2 px-3">
        <button class="btn btn-sm btn-outline-dark px-4" (click)="callbacks.cancel()">
          {{ 'MAIN.LOBBY.NO_DEVICE_MODAL.CANCEL' | translate }}
        </button>
        <button class="btn btn-sm btn-dark px-4" (click)="callbacks.join()">
          {{ 'MAIN.LOBBY.NO_DEVICE_MODAL.JOIN' | translate }}
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #archivePermissionModal let-callbacks="callbacks">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ 'MAIN.LOBBY.ARCHIVE_PERMISSION_MODAL.TITLE' | translate }}</h5>
      </div>
      <div class="modal-body">
        <p>{{ 'MAIN.LOBBY.ARCHIVE_PERMISSION_MODAL.MESSAGE' | translate }}</p>
      </div>
      <div class="modal-footer d-block text-right py-2 px-3">
        <button class="btn btn-sm btn-danger px-4" (click)="callbacks.deny()">{{ 'MAIN.LOBBY.ARCHIVE_PERMISSION_MODAL.DENY' | translate }}</button>
        <button class="btn btn-sm btn-success px-4" (click)="callbacks.allow()">{{ 'MAIN.LOBBY.ARCHIVE_PERMISSION_MODAL.ALLOW' | translate }}</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #smsInputTemplate let-callbacks="callbacks">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ 'MAIN.ROOM.SIDEBAR.SETTINGS.SHARE_LINK_VIA_SMS' | translate }}</h5>
      </div>
      <div class="modal-body" style="padding-top: 1rem;">
        @if (joinSMSForm && smsAccountEnabled) {
          <div class="join-via-sms mt-3">
            <form #smsForm="ngForm" id="smsForm" (ngSubmit)="onSendSMS(smsForm.value)">
              <div class="form-group row">
                <div class="col-sm-6">
                  <ng-container>
                    <ng-select
                      [items]="countryCodes"
                      [clearable]="false"
                      name="countrycodes"
                      bindLabel="number"
                      bindValue="number"
                      placeholder="+93"
                      [(ngModel)]="mobilePhone.selectedCountry"
                      (change)="onMobilePhoneChange()"
                      >
                      <ng-template ng-option-tmp let-item="item" let-index="index">
                        <img height="10" width="15" [src]="item.flag"/>
                        &nbsp;
                        <b>{{item.number}}</b>
                      </ng-template>
                    </ng-select>
                  </ng-container>
                </div>
                <div class="col-sm-6">
                  <input
                    class="field form-control py-2"
                    type="number"
                    autocomplete="off"
                    name="mobilephoneNumber"
                    #mobilephoneAccount="ngModel"
                    [ngClass]="{'is-invalid':mobilephoneAccount.errors && mobilephoneAccount.touched}"
                    [(ngModel)]="mobilePhone.number"
                    placeholder=""
                    (ngModelChange)="onMobilePhoneChange()"
                    (keypress)="numberOnly($event)"
                    style="height: 34px;"
                    >
                </div>
              </div>
              @if (savedPhoneNums[0]) {
                <div class="mb-2">{{ 'MAIN.ROOM.SIDEBAR.SETTINGS.PHONE_NUMBERS' | translate }}</div>
              }
              @for (phoneNum of savedPhoneNums; track phoneNum) {
                <div>
                  <div class="text-info mb-2" style="cursor: pointer;"><a (click)=onPhoneNumClick(phoneNum)> {{ phoneNum.selectedCountry }} {{ phoneNum.number }} </a> </div>
                </div>
              }
              <button [disabled]="!sendEnabled" class="btn btn-sm border" style="font-size: 12px; display: block; width: 100%;" type="submit">{{ 'MAIN.ROOM.SIDEBAR.SETTINGS.SEND' | translate }}</button>
              @if (sendButtonClicked) {
                <div class="mb-2 mt-3" style="font-size: 12px;">{{ 'MAIN.ROOM.SIDEBAR.SETTINGS.DIDNT_GET' | translate }} <a #link class="share-link mr-2" style="cursor: pointer; color: #00a8db" (click)="onSMSRegenerating()">{{ 'MAIN.ROOM.SIDEBAR.SETTINGS.RESEND' | translate }}</a></div>
              }
            </form>
          </div>
        }
      </div>
      <div class="modal-footer d-block text-right py-2 px-3">
        <button class="btn btn-sm btn-outline-dark px-4" (click)="callbacks.close()">{{ 'MAIN.ROOM.SIDEBAR.SETTINGS.CANCEL' | translate }}</button>
      </div>
    </div>
  </div>
</ng-template>